export const EQUIPMENT_HISTORY_PAGE = 'equipmentHistory';
export const EQUIPMENT_DETAILS_PAGE = 'equipmentDetails';

export const dafaultHistory = 'hr';
export const historyBy = {
  hr: { label: 'Hour', days: 7, key: 'hr' },
  day: { label: 'Day', days: 30, key: 'day' },
  month: { label: 'Month', days: 730, key: 'month' },
};

export const historyFont = {
  page: 8,
  zoom: 12,
};

export const historyColor = ['#800080', '#518e01', '#0b4c74', '#e65c00'];

export const historyUnit = Object.freeze({
  tem: 'TEMPERATURE',
  diffTem: 'DIFFERENTIAL TEMPERATURE',
});

export const historyMergeColor = {
  10: '#27ECF4',
  11: '#40CEF4',
  12: '#1EB7FA',
  13: '#3865F2',
  14: '#0A4DA6',
  15: '#245974',
  20: '#AAF549',
  21: '#9CDA4D',
  22: '#0BBE28',
  23: '#00AB4D',
  24: '#77A538',
  25: '#34731A',
  30: '#B107FA',
  31: '#BF4EF0',
  32: '#9D2BBF',
  33: '#E50EA0',
  34: '#7A1697',
  35: '#5E048B',
  40: '#D76630',
  41: '#D87342',
  42: '#E5936A',
  43: '#EAA279',
  44: '#F4C0A1',
  45: '#F4CFB7',
  inActive: '#CCCCCC',
  root: ['#81ACD6', '#B2F34E', '#A32ABE', '#D8632F'],
};

export const parameterHistoryColor = [
  '#036fbf',
  '#518e01',
  '#0b4c74',
  '#e65c00',
  '#81ACD6',
  '#B2F34E',
  '#A32ABE',
  '#D8632F',
  '#5E048B',
  '#0A4DA6',
];

export const siteHistoryUnits = ['CENTIGRADE', 'KILOPASACAL', 'LPS'];
export const SERIAL_NUM_PREFIX = 'S/N';
